import * as React from 'react';
import moment from 'moment';
import { DATE_FORMAT } from 'Src/consts/date';
import { FILTER_TYPE } from 'Src/consts/table';
import { ColumnDefinition } from 'Src/helpers/table/table';
import './StudentBirthday.scss';

// A birthday is a calendar date. UTC keeps it unchanged in every viewer's timezone.
export function StudentBirthday({birthday, labelled = false}: {birthday?: string | null; labelled?: boolean}) {
  const date = birthday ? moment.utc(birthday, moment.ISO_8601, true) : null;
  const valid = date && date.isValid();
  return <span className={valid ? 'studentBirthday' : 'studentBirthday studentBirthday--missing'}>
    {labelled && valid && <span className="studentBirthday__label">Date of birth: </span>}
    {valid ? <time dateTime={date!.format('YYYY-MM-DD')}>{date!.format(DATE_FORMAT)}</time> : <><span aria-hidden="true">⚠ </span>Date of birth missing</>}
  </span>;
}

export const studentBirthdayColumn: ColumnDefinition = {
  text: 'Date of birth', field: 'birthday', type: FILTER_TYPE.NONE, isSort: false,
  cell: row => <td><StudentBirthday birthday={row.birthday} /></td>
};
